const VIDEO_VIEWER_RETURN_FOCUS_KEY = "ama-video-viewer-return-focus";

export function rememberVideoViewerTrigger(triggerId: string) {
  try {
    window.sessionStorage.setItem(VIDEO_VIEWER_RETURN_FOCUS_KEY, triggerId);
  } catch {
    // Focus restoration is progressive enhancement when storage is unavailable.
  }
}

export function getRememberedVideoViewerTrigger() {
  try {
    return window.sessionStorage.getItem(VIDEO_VIEWER_RETURN_FOCUS_KEY);
  } catch {
    return null;
  }
}

export function clearRememberedVideoViewerTrigger() {
  try {
    window.sessionStorage.removeItem(VIDEO_VIEWER_RETURN_FOCUS_KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
}
